// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDM_qQW4ip7QXSS-ebM4qJSf9FUoQfBRVk",
  authDomain: "rexkup-ab8d3.firebaseapp.com",
  projectId: "rexkup-ab8d3",
  storageBucket: "rexkup-ab8d3.firebasestorage.app",
  messagingSenderId: "815863100223",
  appId: "1:815863100223:web:d60ffcd305aecb122d198a",
  measurementId: "G-SJ3S0EVEVD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export the auth object
export const auth = getAuth(app);